import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 579.59 179.76" width="1em" height="1em" {...props}>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={5.27}
        y1={5.27}
        x2={169.64}
        y2={169.64}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.5} stopColor="#514fff" />
        <stop offset={1} stopColor="#514fff" stopOpacity={0.35} />
      </linearGradient>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M18 0h143.76a18 18 0 0118 18v127.21a34.55 34.55 0 01-34.55 34.55H18a18 18 0 01-18-18V18A18 18 0 0118 0z"
          fill="url(#linear-gradient)"
        />
        <path d="M110.44 166.15l11.69-14.4a37.07 37.07 0 0023.38 8.84c8.41 0 12.26-3.14 12.26-8.13 0-5.41-5-7.12-13.12-10.4l-11.83-5.13C123 133.08 114 125 114 111.55c0-15.54 14-28.09 33.65-28.09A44.55 44.55 0 01177.73 95l-11.55 14.4c-6.27-4.42-12.69-6.84-18.53-6.84-6.85 0-11.27 2.71-11.27 7.55 0 5.42 5.85 7.27 14.12 10.55l11.55 4.71c11.54 4.56 18.39 12.26 18.39 25.23 0 15.54-13 29.08-35.36 29.08a49.46 49.46 0 01-34.64-13.53z" />
        <path
          className="cls-2"
          d="M192.69 85.74c0-6.84 5.14-11.26 12.41-11.26s12.4 4.42 12.4 11.26c0 7-5.13 11.41-12.4 11.41s-12.41-4.42-12.41-11.41z"
        />
        <path d="M194.12 107.13h21.96v70.85h-21.96zM234 107.13h18l1.57 8.84h.57c5.7-5.7 12-10.55 21.38-10.55 9.84 0 16 4.13 19.53 11.69 6.13-6.27 12.69-11.69 22.1-11.69 15.4 0 22.24 11 22.24 28.65V178h-22v-41c0-9.84-2.7-12.84-8.26-12.84-3.43 0-7.13 2.14-11.41 6.42V178h-22.1v-41c0-9.84-2.56-12.84-8.27-12.84-3.27 0-7.12 2.14-11.4 6.42V178H234zM356.06 151v-43.87h22.1v41.06c0 9.83 2.57 12.69 8.27 12.69 5 0 8-2 11.83-7.27v-46.48h22.1V178h-18l-1.57-9.69h-.57c-5.85 7-12.55 11.4-22.1 11.4-15.5-.02-22.06-10.99-22.06-28.71zM438.32 155V78.33h21.95v77.56c0 4.56 2.28 6 4 6a9 9 0 002.57-.28l2.57 16.25a29.38 29.38 0 01-11 1.85c-15.1-.02-20.09-9.85-20.09-24.71z" />
        <path
          className="cls-2"
          d="M478.23 85.74c0-6.84 5.14-11.26 12.41-11.26S503 78.9 503 85.74c0 7-5.13 11.41-12.4 11.41s-12.37-4.42-12.37-11.41z"
        />
        <path d="M479.66 107.13h21.96v70.85h-21.96zM515.58 142.49c0-23 16.54-37.07 33.51-37.07 20.52 0 30.5 14.83 30.5 34.07a51.43 51.43 0 01-.85 9.7H537c2 9.55 8.69 13.68 17.67 13.68a30.77 30.77 0 0015.26-4.42l7.07 13.26a45.66 45.66 0 01-25.52 8c-20.22-.02-35.9-13.56-35.9-37.22zm45.19-8.13c0-7-3.13-12.26-11.11-12.26-6.28 0-11.55 4-13 12.26z" />
        <rect
          className="cls-3"
          x={49.43}
          y={19.99}
          width={98.67}
          height={22.3}
          rx={7.41}
        />
        <rect
          className="cls-3"
          x={19.16}
          y={19.99}
          width={22.67}
          height={22.3}
          rx={7.41}
        />
        <rect
          className="cls-3"
          x={49.43}
          y={63.98}
          width={68.67}
          height={22.3}
          rx={7.41}
        />
        <rect
          className="cls-3"
          x={19.16}
          y={63.98}
          width={22.67}
          height={22.3}
          rx={7.41}
        />
        <rect
          className="cls-3"
          x={49.43}
          y={107.97}
          width={43.67}
          height={22.3}
          rx={7.41}
        />
        <rect
          className="cls-3"
          x={19.16}
          y={107.97}
          width={22.67}
          height={22.3}
          rx={7.41}
        />
      </g>
    </g>
  </svg>
);

export default SvgComponent;
